import { useFormik, Form, FormikProvider } from "formik";
import { Button } from "styled";
import InputField from "components/formik/InputField";
import Model from "components/Modal";
import {
  createDocument,
  getAllData,
  updateDocumentByID,
} from "apis/customApiHandler";
import { useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import ReactSelect from "react-select";
import { useState } from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { saveErrorCreationEvent } from "utils/analytics";
import { ANALYTICS_EVENTS } from "utils/analyticsEvents";

const AddVehicle = ({ data, handleClick,getData }) => {
  const [hubs, setHubs] = useState([]);
  const queryClient = useQueryClient();
  const location = useLocation();

  function vehicleEventFunc(eventName, modelName, params) {
    return saveErrorCreationEvent(eventName, modelName, "Vehicles", location.pathname, params);
  }
  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
    getAllData("/customer-fleet", {
      limit: 300,
      page: 1,
    })
  );
  
  const { data: allContractTypes } = useQuery([`/contract-type`], () =>
    getAllData("/contract-type", {
      limit: 300,
      page: 1,
    })
  );
  // const { data: allMechanicalCondition } = useQuery(
  //   [`/mechanical-condition`],
  //   () =>
  //     getAllData("/mechanical-condition", {
  //       limit: 300,
  //       page: 1,
  //     })
  // );
  // const { data: allMechanicalConditionReason } = useQuery(
  //   [`/mechanical-condition-reason-master`],
  //   () =>
  //     getAllData("/mechanical-condition-reason-master", {
  //       limit: 300,
  //       page: 1,
  //     })
  // );
  const { data: allVehicleMake } = useQuery([`/vehicle-make-master`], () =>
    getAllData("/vehicle-make-master", {
      limit: 300,
      page: 1,
    })
  );
  const { data: allVehicleModel } = useQuery([`/vehicle-model-master`], () =>
    getAllData("/vehicle-model-master", {
      limit: 300,
      page: 1,
    })
  );
  const { data: allVehicleConfigration } = useQuery(
    [`/vehicle-configuration-master`],
    () =>
      getAllData("/vehicle-configuration-master", {
        limit: 2000,
        page: 1,
      })
  );
  const { data: allBodyType } = useQuery([`/body-type`], () =>
    getAllData("/body-type", {
      limit: 300,
      page: 1,
    })
  );
  const { data: allApplicationType } = useQuery([`/application-type`], () =>
    getAllData("/application-type", {
      limit: 300,
      page: 1,
    })
  );
  // const { data: allVehicleType } = useQuery([`/vehicle-type`], () =>
  //   getAllData("/vehicle-type", {
  //     limit: 300,
  //     page: 1,
  //   })
  // );

  const { data: allHubs } = useQuery([`/customer-hub`], () =>
    getAllData("/customer-hub", {
      limit: 300,
      page: 1,
    })
  );

  const formik = useFormik({
    initialValues: {
      registrationNumber: data?.registrationNumber || "",
      contractType: data?.contractType?._id || "",
      hub: data?.hub?._id || "",
      mechanicalCondition: data?.mechanicalCondition?._id || "620608a35b52522414b6c16d",
      // mechanicalConditionReason: data?.mechanicalConditionReason?._id || "",
      vehicleMake: data?.vehicleMake?._id || "",
      model: data?.model?._id || "",
      configuration: data?.configuration?._id || "",
      engineNumber: data?.engineNumber || "",
      chasisNumber: data?.chasisNumber || "",
      bodyType: data?.bodyType?._id || "",
      applicationType: data?.applicationType?._id || "",
      registrationYear: data?.registrationYear || "",
      vehicleCC: data?.vehicleCC || "",
      GVW: data?.GVW || "",
      fleet: data?.fleet?._id || "",
    },
    onSubmit: async (values) => {
      const isEdit = !!data;
      const eventParams = {
        registration_number: values.registrationNumber,
        fleets: allFleets?.data?.find((f) => f._id === values.fleet)?.fleetName ?? null,
        hubs: allHubs?.data?.find((h) => h._id === values.hub)?.hubName ?? null,
        contract_type: allContractTypes?.data?.find((c) => c._id === values.contractType)?.name ?? null,
        vehicle_make: allVehicleMake?.data?.find((m) => m._id === values.vehicleMake)?.makeName ?? null,
        vehicle_model: allVehicleModel?.data?.find((m) => m._id === values.model)?.name ?? null,
        configurations: allVehicleConfigration?.data?.find((c) => c._id === values.configuration)?.name ?? null,
        body_type: allBodyType?.data?.find((b) => b._id === values.bodyType)?.name ?? null,
        application_type: allApplicationType?.data?.find((a) => a._id === values.applicationType)?.name ?? null,
        registration_year: values.registrationYear,
        vehicle_cc: values.vehicleCC,
        GVW: values.GVW,
        ...(isEdit && { edited_vehicle_id: data._id }),
      };
      Object.keys(values).forEach((key) => {
        if (values[key] === "") {
          delete values[key];
        }
      });
      try {
        vehicleEventFunc(
          isEdit ? ANALYTICS_EVENTS.CLICK_EDIT_CHANGES : ANALYTICS_EVENTS.CLICK_SAVE_CHANGES,
          isEdit ? "Edit Vehicle" : "Add Vehicle",
          eventParams
        );
        const result = isEdit
          ? await updateDocumentByID("vehicle", data._id, values)
          : await createDocument("vehicle", values);
        if (result) {
          vehicleEventFunc(
            isEdit ? ANALYTICS_EVENTS.SYS_EDIT_VEHICLE_SUCCESS : ANALYTICS_EVENTS.SYS_ADD_VEHICLE_SUCCESS,
            isEdit ? "Edit Vehicle" : "Add Vehicle",
            eventParams
          );
          toast.success("Successfully saved");
        }
        queryClient.invalidateQueries("/vehicle");
        getData();
        handleClick();
      } catch (error) {
        const errMsg = error?.response?.data?.message || error?.message;
        vehicleEventFunc(
          isEdit ? ANALYTICS_EVENTS.SYS_EDIT_VEHICLE_ERROR : ANALYTICS_EVENTS.SYS_ADD_VEHICLE_ERROR,
          isEdit ? "Edit Vehicle" : "Add Vehicle",
          { errMsg }
        );
      }
    },

    validate: (values) => {
      const errors = {};
      if (!values.fleet) errors.fleet = "Required";
      if (!values.hub) errors.hub = "Required";
      if (!values.registrationNumber) errors.registrationNumber = "Required";
      if (!values.contractType) errors.contractType = "Required";
      // if (!values.mechanicalCondition) errors.mechanicalCondition = "Required";
      if (!values.vehicleMake) errors.vehicleMake = "Required";
      if (!values.model) errors.model = "Required";
      if (!values.configuration) errors.configuration = "Required";
      if (!values.bodyType) errors.bodyType = "Required";
      if (!values.applicationType) errors.applicationType = "Required";
      if (!values.registrationYear) errors.registrationYear = "Required";
      if (values.registrationYear && values.registrationYear.length > 4)
        errors.registrationYear = "max 4 digits is allowed";
      if (
        values.registrationYear &&
        values.registrationYear.length <= 4 &&
        /^[0-9]+$/.test(values.registrationYear) === false
      )
        errors.registrationYear = "only digits is allowed";
      if (!values.vehicleCC) errors.vehicleCC = "Required";
      if (values.vehicleCC && values.vehicleCC.length > 5)
        errors.vehicleCC = "max 5 digits is allowed";
      if (
        values.vehicleCC &&
        values.vehicleCC.length <= 5 &&
        /^[0-9]+$/.test(values.vehicleCC) === false
      )
        errors.vehicleCC = "only digits is allowed";
      if (!values.GVW) errors.GVW = "Required";
      if (values.GVW && values.GVW.length > 4)
        errors.GVW = "max 4 digits is allowed";
      if (
        values.GVW &&
        values.GVW.length <= 4 &&
        /^[0-9]+$/.test(values.GVW) === false
      )
        errors.GVW = "only digits is allowed";
      if (!values.fleet) errors.fleet = "Required";
      return errors;
    },
  });
  useEffect(() => {
    allFleets?.data?.map((fleet) => {
      if (formik.values.fleet === fleet._id) {
        const hubData = [];
        allHubs?.data?.map((hub) => {
          if (fleet.fleetCode === hub.fleetCode) {
            hubData.push({
              value: hub._id,
              label: hub.hubName,
            });
          }
        });
        setHubs([...hubData]);
      }
    });
  }, [formik.values.fleet]);

  return (
    <Model
      handleClick={handleClick}
      title={data ? "Update Vehicle" : "Add Vehicle"}
      className="max-w-2xl"
    >
      <FormikProvider value={formik}>
        <Form className="px-5 text-gray-700 font-medium text-base grid  lg:gap-x-14 gap-y-5 grid-flow-row grid-cols-1 lg:grid-cols-2 w-full">
          <div className="flex flex-col gap-0 text-gray-600 font-normal">
            <label className="py-3">
              Select Fleet
              <ReactSelect
                styles={{
                  control: (base, state) => ({
                      ...base,
                      borderColor: "transparent",
                      minWidth: "100%",
                      "&:hover": {
                      borderColor: "rgb(34 197 94)",
                      },
                  }),
                }}
                className="shadow-md rounded-md py-1 mb-2"
                options={allFleets?.data?.map((fleet) => ({
                  value: fleet._id,
                  label: fleet.fleetName,
                }))}
                value={{
                  value: formik.values.fleet,
                  label: allFleets?.data?.find(
                    (d) => d?._id === formik.values.fleet
                  )?.fleetName,
                }}
                onChange={(value) => {
                  formik.setFieldValue("fleet", value.value);
                  formik.setFieldValue("hub", "");
                }}
                name="fleet"
                isMulti={false}
              />
              {formik.touched.fleet && formik.errors.fleet && (
                <p className="text-red-500 font-normal">*{formik.errors.fleet}</p>
              )}
            </label>
          </div>
          <div className="flex flex-col gap-0 text-gray-600 font-normal">
            <label className="py-3">
              Select Hub
              <ReactSelect
              styles={{
                control: (base, state) => ({
                    ...base,
                    borderColor: "transparent",
                    minWidth: "100%",
                    "&:hover": {
                    borderColor: "rgb(34 197 94)",
                    },
                }),
                }}
                className="shadow-md rounded-md py-1 mb-2"
                options={hubs}
                value={{
                  value: formik.values.hub,
                  label: allHubs?.data?.find((d) => d?._id === formik.values.hub)
                    ?.hubName,
                }}
                onChange={(value) => {
                  formik.setFieldValue("hub", value.value);
                }}
                name="hub"
                isMulti={false}
              />
              {formik.touched.hub && formik.errors.hub && (
                <p className="text-red-500 font-normal">*{formik.errors.hub}</p>
              )}
            </label>
          </div>
          <InputField
            type="text"
            label="Registration Number"
            name="registrationNumber"
          />
          <div className="flex flex-col gap-0 text-gray-600 font-normal">
            <label className="py-3">
              Contract Type
              <ReactSelect
              styles={{
                control: (base, state) => ({
                    ...base,
                    borderColor: "transparent",
                    minWidth: "100%",
                    "&:hover": {
                    borderColor: "rgb(34 197 94)",
                    },
                }),
                }}
                className="shadow-md rounded-md py-1 mb-2"
                options={allContractTypes?.data?.map((con) => ({
                  value: con._id,
                  label: con.name,
                }))}
                value={{
                  value: formik.values.contractType,
                  label: allContractTypes?.data?.find(
                    (con) => con?._id === formik.values.contractType
                  )?.name,
                }}
                onChange={(value) => {
                  formik.setFieldValue("contractType", value.value);
                }}
                name="contractType"
                isMulti={false}
              />
              {formik.touched.contractType && formik.errors.contractType && (
                <p className="text-red-500 font-normal">
                  *{formik.errors.contractType}
                </p>
              )}
            </label>
          </div>
          {/* <div className="flex flex-col gap-0 text-gray-600 font-normal">
            <label className="py-3">
              Mechanical Condition
              <ReactSelect
              styles={{
                control: (base, state) => ({
                    ...base,
                    borderColor: "transparent",
                    minWidth: "100%",
                    "&:hover": {
                    borderColor: "rgb(34 197 94)",
                    },
                }),
                }}
                className="shadow-md rounded-md py-1 mb-2"
                options={allMechanicalCondition?.data?.map((item) => ({
                  value: item._id,
                  label: item.name,
                }))}
                value={{
                  value: formik.values.mechanicalCondition,
                  label: allMechanicalCondition?.data?.find(
                    (d) => d?._id === formik.values.mechanicalCondition
                  )?.name,
                }}
                onChange={(value) => {
                  formik.setFieldValue("mechanicalCondition", value.value);
                }}
                name="mechanicalCondition"
                isMulti={false}
              />
              {formik.touched.mechanicalCondition &&
                formik.errors.mechanicalCondition && (
                  <p className="text-red-500 font-normal">
                    *{formik.errors.mechanicalCondition}
                  </p>
                )}
            </label>
          </div>
          {formik.values.mechanicalCondition &&
            allMechanicalCondition?.data?.find(
              (d) => d?._id === formik.values.mechanicalCondition
            )?.code === "NOTO3011" && (
              <div className="flex flex-col gap-0 text-gray-600 font-normal">
                <label className="py-3">
                  Mechanical Condition Reason
                  <ReactSelect
                  styles={{
                    control: (base, state) => ({
                        ...base,
                        borderColor: "transparent",
                        minWidth: "100%",
                        "&:hover": {
                        borderColor: "rgb(34 197 94)",
                        },
                    }),
                    }}
                    className="shadow-md rounded-md py-1 mb-2"
                    options={allMechanicalConditionReason?.data?.map((item) => ({
                      value: item._id,
                      label: item.name,
                    }))}
                    value={{
                      value: formik.values.mechanicalConditionReason,
                      label: allMechanicalConditionReason?.data?.find(
                        (d) => d?._id === formik.values.mechanicalConditionReason
                      )?.name,
                    }}
                    onChange={(value) => {
                      formik.setFieldValue(
                        "mechanicalConditionReason",
                        value.value
                      );
                    }}
                    name="mechanicalConditionReason"
                    isMulti={false}
                  />
                </label>
              </div>
            )} */}
          <div className="flex flex-col gap-0 text-gray-600 font-normal">
            <label className="py-3">
              Vehicle Make
              <ReactSelect
              styles={{
                control: (base, state) => ({
                    ...base,
                    borderColor: "transparent",
                    minWidth: "100%",
                    "&:hover": {
                    borderColor: "rgb(34 197 94)",
                    },
                }),
                }}
                className="shadow-md rounded-md py-1 mb-2"
                isDisabled = {data?.tyres?.length}
                options={allVehicleMake?.data?.map((item) => ({
                  value: item._id,
                  label: item.makeName,
                }))}
                value={{
                  value: formik.values.vehicleMake,
                  label: allVehicleMake?.data?.find(
                    (d) => d?._id === formik.values.vehicleMake
                  )?.make,
                }}
                onChange={(value) => {
                  formik.setFieldValue("vehicleMake", value.value);
                  formik.setFieldValue("model", "");
                  formik.setFieldValue("configuration", "");
                }}
                name="vehicleMake"
                isMulti={false}
              />
              {formik.touched.vehicleMake && formik.errors.vehicleMake && (
                <p className="text-red-500 font-normal">
                  *{formik.errors.vehicleMake}
                </p>
              )}
            </label>
          </div>
          <div className="flex flex-col gap-0 text-gray-600 font-normal">
            <label className="py-3">
              Vehicle Model
              <ReactSelect
              styles={{
                control: (base, state) => ({
                    ...base,
                    borderColor: "transparent",
                    minWidth: "100%",
                    "&:hover": {
                    borderColor: "rgb(34 197 94)",
                    },
                }),
                }}
                className="shadow-md rounded-md py-1 mb-2"
                isDisabled = {data?.tyres?.length}
                options={allVehicleModel?.data
                  ?.filter((m) => m.make?._id === formik.values.vehicleMake)
                  ?.map((item) => ({
                    value: item._id,
                    label: item.name,
                  }))}
                value={{
                  value: formik.values.model,
                  label: allVehicleModel?.data?.find(
                    (d) => d?._id === formik.values.model
                  )?.name,
                }}
                onChange={(value) => {
                  formik.setFieldValue("model", value.value);
                  formik.setFieldValue("configuration", "");
                }}
                name="model"
                isMulti={false}
              />
              {formik.touched.model && formik.errors.model && (
                <p className="text-red-500 font-normal">*{formik.errors.model}</p>
              )}
            </label>
          </div>
          <div className="flex flex-col gap-0 text-gray-600 font-normal">
            <label className="py-3">
              Vehicle Configuration
              <ReactSelect
              styles={{
                control: (base, state) => ({
                    ...base,
                    borderColor: "transparent",
                    minWidth: "100%",
                    "&:hover": {
                    borderColor: "rgb(34 197 94)",
                    },
                }),
                }}
                className="shadow-md rounded-md py-1 mb-2"
                isDisabled = {data?.tyres?.length}
                options={allVehicleConfigration?.data
                  ?.filter(
                    (m) =>
                      m.make?._id === formik.values.vehicleMake &&
                      m.model?._id === formik.values.model
                  )
                  ?.map((item) => ({
                    value: item._id,
                    label: item.name,
                  }))}
                value={{
                  value: formik.values.configuration,
                  label: allVehicleConfigration?.data?.find(
                    (d) => d?._id === formik.values.configuration
                  )?.name,
                }}
                onChange={(value) => {
                  formik.setFieldValue("configuration", value.value);
                }}
                name="configuration"
                isMulti={false}
              />
              {formik.touched.configuration && formik.errors.configuration && (
                <p className="text-red-500 font-normal">
                  *{formik.errors.configuration}
                </p>
              )}
            </label>
          </div>
          <InputField type="text" label="Engine Number" name="engineNumber" />
          <InputField type="text" label="Chassis Number" name="chasisNumber" />
          <div className="flex flex-col gap-0 text-gray-600 font-normal">
            <label className="py-3">
              Body Type
              <ReactSelect
              styles={{
                control: (base, state) => ({
                    ...base,
                    borderColor: "transparent",
                    minWidth: "100%",
                    "&:hover": {
                    borderColor: "rgb(34 197 94)",
                    },
                }),
                }}
                className="shadow-md rounded-md py-1 mb-2"
                options={allBodyType?.data?.map((item) => ({
                  value: item._id,
                  label: item.name,
                }))}
                value={{
                  value: formik.values.bodyType,
                  label: allBodyType?.data?.find(
                    (d) => d?._id === formik.values.bodyType
                  )?.name,
                }}
                onChange={(value) => {
                  formik.setFieldValue("bodyType", value.value);
                }}
                name="bodyType"
                isMulti={false}
              />
              {formik.touched.bodyType && formik.errors.bodyType && (
                <p className="text-red-500 font-normal">
                  *{formik.errors.bodyType}
                </p>
              )}
            </label>
          </div>
          <div className="flex flex-col gap-0 text-gray-600 font-normal">
            <label className="py-3">
              Application Type
              <ReactSelect
              styles={{
                control: (base, state) => ({
                    ...base,
                    borderColor: "transparent",
                    minWidth: "100%",
                    "&:hover": {
                    borderColor: "rgb(34 197 94)",
                    },
                }),
                }}
                className="shadow-md rounded-md py-1 mb-2"
                options={allApplicationType?.data?.map((item) => ({
                  value: item._id,
                  label: item.name,
                }))}
                value={{
                  value: formik.values.applicationType,
                  label: allApplicationType?.data?.find(
                    (d) => d?._id === formik.values.applicationType
                  )?.name,
                }}
                onChange={(value) => {
                  formik.setFieldValue("applicationType", value.value);
                }}
                name="applicationType"
                isMulti={false}
              />
              {formik.touched.applicationType &&
                formik.errors.applicationType && (
                  <p className="text-red-500 font-normal">
                    *{formik.errors.applicationType}
                  </p>
                )}
            </label>
          </div>
          <InputField
            type="text"
            label="Registration Year"
            name="registrationYear"
          />
          <InputField type="text" label="Vehicle CC" name="vehicleCC" />
          <InputField type="text" label="GVW" name="GVW" />
        </Form>
        <div className="px-5 flex justify-end items-center gap-4 pb-8 flex-wrap sm:w-full">
          <Button bgSecondary onClick={handleClick}>
            Cancel
          </Button>
          <Button type="button" bgPrimary onClick={formik.handleSubmit}>
            Save Changes
          </Button>
        </div>
      </FormikProvider>
    </Model>
  );
};

export default AddVehicle;
